import React from 'react';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';
import store from '../../redux/store';
import { EventsContainer } from '../EventsContainer/EventsContainer';

export const AppContainer = () => {
  return (
    <IntlProvider>
      <Provider store={store}>
        <div className="mt-6 flex flex-col gap-8">
          <EventsContainer />
        </div>
      </Provider>
    </IntlProvider>
  );
};
